import React from 'react'
import SEO from '../seo'
import PageTitle from '../page-title'
import SubTitle from '../sub-title'
import styles from './Sponsors.module.css'

const SPONSOR_TYPE = {
  EVENT: 'event',
  CLOTHING: 'clothing',
  MEDIA: 'media',
}

const sponsors = [
  {
    name: 'Indian oil corporation',
    category: SPONSOR_TYPE.EVENT,
  },
  {
    name: 'Hindustan petroleum',
    category: SPONSOR_TYPE.EVENT,
  },
  {
    name: 'Bank of India',
    category: SPONSOR_TYPE.EVENT,
  },
  {
    name: 'Steel authority of India limited',
    category: SPONSOR_TYPE.EVENT,
  },
  {
    name: 'Hindustan insecticides limited',
    category: SPONSOR_TYPE.EVENT,
  },
  {
    name: 'Rural electrification corporation',
    category: SPONSOR_TYPE.EVENT,
  },
  {
    name: 'Power finance corporation',
    category: SPONSOR_TYPE.EVENT,
  },
  {
    name: 'State bank of India',
    category: SPONSOR_TYPE.EVENT,
  },
  {
    name: 'Life insurance corporation',
    category: SPONSOR_TYPE.EVENT,
  },
  {
    name: 'India tourism development corporation',
    category: SPONSOR_TYPE.EVENT,
  },
  {
    name: 'National thermal power corporation',
    category: SPONSOR_TYPE.EVENT,
  },
  {
    name: 'Oriental bank insurance',
    category: SPONSOR_TYPE.EVENT,
  },
  {
    name: 'Samtel Avionics',
    category: SPONSOR_TYPE.EVENT,
  },
  {
    name: 'Central bank of India',
    category: SPONSOR_TYPE.EVENT,
  },
  {
    name: 'National Insurance',
    category: SPONSOR_TYPE.EVENT,
  },
  {
    name: 'Gadgil jewellers',
    category: SPONSOR_TYPE.EVENT,
  },
  {
    name: 'New India assurance limited',
    category: SPONSOR_TYPE.EVENT,
  },
  {
    name: 'Kohinoor foods',
    category: SPONSOR_TYPE.EVENT,
  },
  {
    name: 'Alankrit',
    category: SPONSOR_TYPE.CLOTHING,
  },
  {
    name: 'Accent',
    category: SPONSOR_TYPE.CLOTHING,
  },
  {
    name: 'Doordarshan',
    category: SPONSOR_TYPE.MEDIA,
  },
  {
    name: 'All India radio',
    category: SPONSOR_TYPE.MEDIA,
  },
]

const eventSponsors = sponsors.filter(
  item => item.category === SPONSOR_TYPE.EVENT
)
const clothingSponsors = sponsors.filter(
  item => item.category === SPONSOR_TYPE.CLOTHING
)
const mediaSponsors = sponsors.filter(
  item => item.category === SPONSOR_TYPE.MEDIA
)

const groupedSponsors = [
  {
    list: eventSponsors,
    title: 'Event Sponsors',
  },
  {
    list: clothingSponsors,
    title: 'Clothing sponsors',
  },
  {
    list: mediaSponsors,
    title: 'Media Coverage',
  },
]

const pageInfo = {
  title: 'Past sponsors',
  description:
    'Sponsors play a vital role in helping us create beautiful shows and bringing forward talented artists from all over India.',
}

const SponsorCategorySection = ({ list, title }) => (
  <section>
    <header>
      <SubTitle>{title}</SubTitle>
    </header>

    <ul className={styles.list}>
      {list.map(({ name }, index) => (
        <li key={index}>{name}</li>
      ))}
    </ul>
  </section>
)

const Sponsors = () => {
  return (
    <div className={styles.container}>
      <SEO {...pageInfo} />

      <PageTitle>Sponsors</PageTitle>
      <p>{pageInfo.description}</p>

      {groupedSponsors.map((sponsorGroupData, index) => (
        <SponsorCategorySection key={index} {...sponsorGroupData} />
      ))}
    </div>
  )
}

export default Sponsors
